
/**
 * Remove entires from source that exist in duplicates
 * @param {*} source - the list to remove duplicates from i.e. surveyQuestions
 * @param {*} duplicates - the duplicates to check - assumes it is the id field
 * i.e. the items already selected surveyGroups.questions - map to id field in the list
 */
export const filterDuplicatesById = (source, duplicates) => {
    return source.filter(entry => notDuplicateById(entry, duplicates));
};

/**
 * call using the array filter method - refer to filterDuplicatesById
 * @param {*} currentValue 
 */
export const notDuplicateById = (currentValue, duplicates) => {
    let notDuplicate = true;
    if (duplicates) {
        for (const duplicate of duplicates) {
            if (duplicate === currentValue.id) {
                notDuplicate = false;
                break;
            }
        }
    }
    return notDuplicate;
};



// WEBPACK FOOTER //
// ./services/DataFormatters.js